import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, Box, Typography, Chip, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useThemeMode } from '../theme/ThemeContext';

const SHORTCUTS = [
    { keys: ['N'], label: 'Create new task' },
    { keys: ['/'], label: 'Focus search bar' },
    { keys: ['1'], label: 'Scroll to To Do' },
    { keys: ['2'], label: 'Scroll to Planned' },
    { keys: ['3'], label: 'Scroll to Doing' },
    { keys: ['4'], label: 'Scroll to Done' },
    { keys: ['Cmd', 'K'], label: 'Open command palette', alt: ['Ctrl', 'K'] },
    { keys: ['?'], label: 'Show this help' },
    { keys: ['Esc'], label: 'Close dialog' }
];

const KeyboardShortcutsHelp = () => {
    const [open, setOpen] = useState(false);
    const { themeMode } = useThemeMode();
    const isDark = themeMode === 'dark';

    useEffect(() => {
        const handleKey = (e) => {
            if (e.key === '?' && !e.target.matches('input, textarea, [contenteditable]')) {
                e.preventDefault();
                setOpen(true);
            }
        };
        window.addEventListener('keydown', handleKey);
        return () => window.removeEventListener('keydown', handleKey);
    }, []);

    const keyChip = (k, i) => (
        <Chip
            key={i}
            label={k}
            size="small"
            sx={{
                height: 24,
                fontSize: '11px',
                fontWeight: 700,
                fontFamily: 'monospace',
                backgroundColor: isDark ? '#333' : '#f0f0f0',
                color: isDark ? '#e0e0e0' : '#1f2d3d',
                border: `1px solid ${isDark ? '#444' : '#ddd'}`,
                borderRadius: '4px'
            }}
        />
    );

    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            maxWidth="xs"
            fullWidth
            PaperProps={{ sx: { borderRadius: '12px', background: isDark ? '#1e1e1e' : '#fff' } }}
        >
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 1 }}>
                <Typography sx={{ fontWeight: 700, fontSize: '16px', color: isDark ? '#e0e0e0' : '#1f2d3d' }}>
                    Keyboard Shortcuts
                </Typography>
                <IconButton size="small" onClick={() => setOpen(false)} sx={{ color: isDark ? '#ccc' : '#666' }}>
                    <CloseIcon fontSize="small" />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ pt: 1 }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
                    {SHORTCUTS.map((s, idx) => (
                        <Box key={idx} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <Typography sx={{ fontSize: '13px', color: isDark ? '#ccc' : '#555' }}>
                                {s.label}
                            </Typography>
                            <Box sx={{ display: 'flex', gap: 0.5 }}>
                                {s.keys.map(keyChip)}
                            </Box>
                        </Box>
                    ))}
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default KeyboardShortcutsHelp;
